import { c as _c } from "react/compiler-runtime";
import { BrandLogo } from 'shared/components/brand-logo';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
interface BrandLogoLinkProps {
  href?: string;
}
const logo = <BrandLogo className="size-8 min-w-8 object-cover" loaderClassName="size-8 min-w-8" />;
export function BrandLogoLink(t0) {
  const $ = _c(2);
  const {
    href
  } = t0;
  if (!href) {
    return logo;
  }
  let t1;
  if ($[0] !== href) {
    t1 = <LinkWithoutPrefetch className="focus-visible:focus-ring-primary rounded-full" href={href}>{logo}</LinkWithoutPrefetch>;
    $[0] = href;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}